
export const SummaryApprovedBuys = ({
    approvedBuyRows,
    draftedPOs,
    approvalLogEntries,
}) => {
    return (
        <div className="mt-4 grid gap-2 text-sm text-gray-600 sm:grid-cols-3">
            <div className="rounded-md border border-border bg-background px-3 py-2">
                <p className="text-[11px] uppercase tracking-[0.12em]">
                    Approved BUY rows
                </p>
                <p className="mt-1 text-lg font-semibold text-primary">
                    {approvedBuyRows}
                </p>
            </div>
            <div className="rounded-md border border-border bg-background px-3 py-2">
                <p className="text-[11px] uppercase tracking-[0.12em]">
                    Drafted POs
                </p>
                <p className="mt-1 text-lg font-semibold text-primary">
                    {draftedPOs}
                </p>
            </div>
            <div className="rounded-md border border-border bg-background px-3 py-2">
                <p className="text-[11px] uppercase tracking-[0.12em]">
                    Approval log entries
                </p>
                <p className="mt-1 text-lg font-semibold text-primary">
                    {approvalLogEntries}
                </p>
            </div>
        </div>
    )
}